import React, { Component, useState } from 'react';
import MyAccountView from './MyAccountView';
import { getAppCfg } from '../../utils/common';
import MyOrderCards from '../order-cards/Cards'
import MyRewardCards from '../reward-cards/Cards'
import Addresses from '../addresses/Addresses';
import ParticipatingSchemes from '../participating-schemes/ParticipatingSchemes'
import SpendingPreferencesController from '../spending-preferences/SpendingPreferencesController';
import Transactions from '../transactions/Transactions';
import { custom_page } from '../../../portal.custom.page.config';

var TransactionsComponent = custom_page.transactions ? custom_page.transactions : Transactions;

function MyAccount(props) {
    const [open, setOpen] = useState({});

    const onClickItem = (value) =>{
        setOpen(prevState =>({
            ...prevState,
            [value] : true
        }));
    }
    const onCloseItem = (value) => {
        setOpen(prevState =>({
            ...prevState,
            [value] : false
        }));
    }

        
        //console.log('MoreInfo  this.props.openMoreInfo=',this.props.openMoreInfo)
        return (
            <div>
                {/* <MoreInfoMenu open={this.props.openMoreInfo} handleDrawerToggle={this.props.handleDrawerToggleMF} /> */}
                {props.open && <MyAccountView 
                    open = {props.open}
                    handleDrawerOtherToggle = {props.handleDrawerOtherToggle}
                    onClickItem = {onClickItem}/>}
                {open.my_cards_orders && <MyOrderCards  
                    open = {open.my_cards_orders}
                    setOpen={setOpen}
                    onCloseItem = {()=>onCloseItem('my_cards_orders')}/>}
                {open.my_cards_rewards && <MyRewardCards  
                    open = {open.my_cards_rewards}
                    onCloseItem = {()=>onCloseItem('my_cards_rewards')}/>}
                {open.address_book && <Addresses
                    open = {open.address_book}
                    onCloseItem = {onCloseItem}/>}
                {open.participating_schemes && <ParticipatingSchemes
                    open = {open.participating_schemes} 
                    onCloseItem = {onCloseItem}/>}
                {open.spending_preferences && <SpendingPreferencesController
                    open = {open.spending_preferences}
                    onCloseItem = {()=>onCloseItem('spending_preferences')}/>}
                {open.transactions && <TransactionsComponent open = {open.transactions}
                    handleDrawerOtherToggle = {onCloseItem}/> }
            </div>
        );
}

export default MyAccount;